import { getConfig } from './config'
import { CardTokenizerResponse } from './mundipagg'

type CancelParams = {
  reason?: string
}

export type Subscription = {
  cardToken?: CardTokenizerResponse
  couponCode?: string
  zipCode: string
  personNumber: string
  planId: string
  ownerName: string
}

export type Statement = {
  _id: string
  createdAt: Date
  name: string
  amount: number
  lastFourDigits: string
  brand: string
}

export const cancel = async (params: CancelParams): Promise<void> => {
  const config = getConfig()
  await config.axios.delete(`${config.API_URL}/subscriptions`, { params })
}

export const subscribe = async (params: Subscription): Promise<void> => {
  const config = getConfig()
  await config.axios.post(`${config.API_URL}/subscriptions`, params)

  // return data
}

export const statement = async (): Promise<Statement[]> => {
  const config = getConfig()
  const { data } = await config.axios.get<Statement[]>(`${config.API_URL}/subscriptions/statement`)

  return data
}

// export const get = async ({ userId, ...restParams }) => {
//   if (userId) {
//     return axios.get(`${config.API_URL}/subscriptions/users/${userId}`, { params: restParams })
//   }
//   // return axios.get(`${config.API_URL}/users`, { params: restParams })
// }

// export const changeTrialDate = async ({ userId, ...params }) => {
//   return axios.patch(`${config.API_URL}/subscriptions/users/${userId}/trial-date`, params)
// }

// export const applyCoupon = async ({ userId, ...params }) => {
//   return axios.patch(`${config.API_URL}/subscriptions/users/${userId}/apply-coupon`, params)
// }
